<template>
    <div class="container">
        <b-tabs
            v-model="tabIndex"
            content-class="mt-3"
            align="left">
            <b-tab
                v-if="showSelectProfile"
                title-link-class="h3 tab"
                title="Select a Profile">
                <div
                    style="gap: 24px;"
                    class="py-5 d-flex flex-column">
                    <b-alert
                        v-if="infoContent"
                        variant="info"
                        show>
                        <b-icon-exclamation-circle class="mr-3"></b-icon-exclamation-circle>
                        {{ infoContent }}
                    </b-alert>
                    <b-alert
                        variant="info"
                        show>
                        <b-icon-exclamation-circle class="mr-3"></b-icon-exclamation-circle>
                        The below profiles are associated with your One Healthcare ID.
                        If you do not see the profile you are looking for, select the
                        <span class="font-weight-bold">Link a Profile</span> tab.
                    </b-alert>
                </div>
                <profile-list
                    :profiles="profilesList"
                    class="w-50" />
            </b-tab>
            <b-tab
                title-link-class="h3 tab"
                title="Link a Profile">
                <b-alert
                    variant="info"
                    show>
                    <b-icon-exclamation-circle class="mr-3"></b-icon-exclamation-circle>
                    If you are already a registered user of myVACCN.com, please enter your username and password.
                    If not, please select Register now.
                </b-alert>
                <link-profile :set-tab="setTab" />
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import PgbaBaseComponent from '../../common/components/PgbaBaseComponent.vue';
import ProfileList from './ProfileList.vue';
import LinkProfile from './LinkProfile.vue';

export default {
    name: 'ProfileSelect',
    components: {
        ProfileList,
        LinkProfile
    },
    extends: PgbaBaseComponent,
    data: () => {
        return {
            profiles: null,
            tabIndex: 0,
            infoContent: ''
        };
    },
    computed: {
        showSelectProfile() {
            return this.profiles === null || this.profilesList.length > 0;
        },
        profilesList() {
            return this.profiles !== null ? this.profiles : [];
        }
    },
    mounted() {
        this.showLoading();

        this.retrieveProfiles()
            .then((profiles) => {
                this.profiles = profiles;
                // if there is a single prime retrieved then log them in
                if (profiles.length === 1 && profiles[0].constituentType === 'Prime') {
                    window.location.href
                        = `/tri-inbound-sso-web/sso/select-profile?UserName=${profiles[0].userName}`;
                    return;
                }
                if (this.profiles.length === 0) {
                    this.setTab(1);  // take user to link an existing tab
                }
            })
            .catch(() => {
                // if this call failed, they likely didnt SSO in and went straight to the select
                // profile page so lets redirect them to the nonsecure homepage to SSO in properly
                window.location.href = '/vaccn';
            })
            .finally(() => {
                this.hideLoading();
            });
    },
    methods: {
        ...mapActions('selectProfile', [
            'retrieveProfiles'
        ]),
        setTab(tabIndex) {
            this.tabIndex = tabIndex;
        }
    }
};
</script>

<style>
.tab {
    text-decoration: none !important;
}

.container {
    font-family: 'Open Sans', sans-serif;
    font-size: 16px;
}
</style>
